export default __webpack_public_path__ + "static/media/header.c180ddd9.webp";